import { toast } from "react-toastify";

export const handleOperationError = (
  operation: string,
  error: unknown,
): void => {
  console.error(`Failed to ${operation}:`, error);
  toast.error(`Failed to ${operation}`);
};
